export default {
  data() {
    return { dragTarget: null, dragValid: true, dragCount: 0 }
  },
  methods: {
    isFileDrag(e) {
      return Boolean(e.dataTransfer) && Array.from(e.dataTransfer.types || []).includes('Files')
    },
    onTileDragOver(e, target) {
      if (this.dropDisabled || !this.isFileDrag(e)) return
      e.preventDefault()
      const items = Array.from(e.dataTransfer.items)
      const isImages = items.every(item => item.kind === 'file' && item.type.indexOf('image/') === 0)
      this.dragValid = isImages && this.dropAccepts(target, items.length)
      this.dragCount = items.length
      this.dragTarget = target
    },
    onTileDragLeave(e, target) {
      if (this.dragTarget !== target) return
      if (e.relatedTarget && e.currentTarget.contains(e.relatedTarget)) return
      this.dragTarget = null
      this.dragValid = true
      this.dragCount = 0
    },
    onTileDrop(e, target) {
      if (this.dropDisabled || !this.isFileDrag(e)) return
      e.preventDefault()
      const valid = this.dragValid
      this.dragTarget = null
      this.dragValid = true
      this.dragCount = 0
      if (!valid) return
      const files = Array.from(e.dataTransfer.files).filter(file => file.type.indexOf('image/') === 0)
      if (!files.length) return
      this.onDropFiles(target, files)
    },
  },
}
